import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
import { tw } from "@careinfo/tailwind";
import { getKey } from "../../helpers/sessionKey";
import { useState } from "react";
import { usePDFPrintHook } from "@careinfo/layout";
import { useNavigate } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
const CreateExpenseNoteComponent = loadable(
  () => import("../../components/ExpenseNote/CreateExpenseNote")
);

const CreateExpenseNote = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["expense-note"],
    navigateURL: "",
  });

  const { data, isLoading: isDataLoading } = useGetHook({
    queryKey: ["ship-via"],
    url: `${APIS.SHIP_VIA}`,
    params: {
      is_default: true,
    },
  });

  const navigate = useNavigate();
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [expenseNoteId, setExpenseNoteId] = useState(false);

  const handleCreate = async (values: any, openPrintPopup, setError: any) => {
    const url = `${APIS.EXPENSE_NOTE}`;
    const formatContact = (number) => {
      if (!number) return null;
      return number.startsWith("+977") ? number : `+977${number}`;
    };
    let formData = {
      ...values,
      receiver_phone_number: formatContact(values?.receiver_phone_number),
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        if (openPrintPopup) {
          setOpenPrintPopup(true);
          setExpenseNoteId(res?.data?.id);
        } else {
          navigate("/");
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const defaultBranch = getKey("default-branch");

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handleSlipPrint = async () => {
    const url = `${APIS.EXPENSE_NOTE}print/`;
    let formData = {
      ids: [expenseNoteId],
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Expense Note
        </span>
      </div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <CreateExpenseNoteComponent
          handleCreate={handleCreate}
          isLoading={isPostLoading}
          defaultBranch={defaultBranch}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          handleSlipPrint={handleSlipPrint}
          isPrintLoading={isPrintLoading}
          data={data}
        />
      )}
    </>
  );
};

export default CreateExpenseNote;
